import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  ar: {
    translation: {
      // Navigation
      home: 'الرئيسية',
      about: 'من نحن',
      services: 'الخدمات',
      departments: 'الأقسام',
      blog: 'المدونة',
      contact: 'اتصل بنا',
      login: 'تسجيل الدخول',
      register: 'إنشاء حساب',
      logout: 'تسجيل الخروج',
      
      // Hero Section
      heroTitle: 'شركة وازن للمحاماة والاستشارات القانونية',
      heroSubtitle: 'شريككم القانوني الموثوق في المملكة العربية السعودية',
      heroDescription: 'نقدم حلول قانونية متكاملة بأحدث التقنيات والذكاء الاصطناعي',
      getStarted: 'ابدأ الآن',
      learnMore: 'اعرف المزيد',
      
      // Dashboard
      dashboard: 'لوحة التحكم',
      myCases: 'قضاياي',
      documents: 'المستندات',
      hearings: 'الجلسات',
      notifications: 'الإشعارات',
      profile: 'الملف الشخصي',
      
      // Cases
      cases: 'القضايا',
      caseNumber: 'رقم القضية',
      caseTitle: 'عنوان القضية',
      caseDescription: 'وصف القضية',
      caseStatus: 'حالة القضية',
      createCase: 'إنشاء قضية جديدة',
      viewCase: 'عرض القضية',
      editCase: 'تعديل القضية',
      
      // Status
      pending: 'قيد الانتظار',
      active: 'نشطة',
      closed: 'مغلقة',
      appealed: 'مستأنفة',
      
      // Common
      save: 'حفظ',
      cancel: 'إلغاء',
      delete: 'حذف',
      edit: 'تعديل',
      view: 'عرض',
      upload: 'رفع',
      download: 'تحميل',
      search: 'بحث',
      filter: 'تصفية',
      loading: 'جاري التحميل...',
      noData: 'لا توجد بيانات',
      success: 'تم بنجاح',
      error: 'حدث خطأ',
      
      // Auth
      email: 'البريد الإلكتروني',
      password: 'كلمة المرور',
      fullName: 'الاسم الكامل',
      phone: 'رقم الجوال',
      loginTitle: 'تسجيل الدخول',
      registerTitle: 'إنشاء حساب جديد',
      forgotPassword: 'نسيت كلمة المرور؟',
      dontHaveAccount: 'ليس لديك حساب؟',
      alreadyHaveAccount: 'لديك حساب بالفعل؟',
      
      // Services
      ourServices: 'خدماتنا القانونية',
      individuals: 'للأفراد',
      businesses: 'للشركات',
      litigation: 'التقاضي',
      contracts: 'العقود',
      consultation: 'الاستشارات',
      
      // Departments
      legalDepartments: 'الأقسام القانونية',
      litigationDept: 'قسم التقاضي',
      contractsDept: 'قسم العقود',
      intellectualProperty: 'الملكية الفكرية',
      cybercrimes: 'الجرائم الإلكترونية',
      realEstate: 'التسجيل العقاري',
      
      // Contact
      contactUs: 'تواصل معنا',
      sendMessage: 'إرسال الرسالة',
      message: 'الرسالة',
      subject: 'الموضوع',
      
      // Footer
      allRightsReserved: 'جميع الحقوق محفوظة',
      privacyPolicy: 'سياسة الخصوصية',
      termsConditions: 'الشروط والأحكام',
    }
  },
  en: {
    translation: {
      // Navigation
      home: 'Home',
      about: 'About',
      services: 'Services',
      departments: 'Departments',
      blog: 'Blog',
      contact: 'Contact',
      login: 'Login',
      register: 'Register',
      logout: 'Logout',
      
      // Hero Section
      heroTitle: 'Wazin Law Firm',
      heroSubtitle: 'Your Trusted Legal Partner in Saudi Arabia',
      heroDescription: 'Comprehensive legal solutions powered by AI technology',
      getStarted: 'Get Started',
      learnMore: 'Learn More',
      
      // Dashboard
      dashboard: 'Dashboard',
      myCases: 'My Cases',
      documents: 'Documents',
      hearings: 'Hearings',
      notifications: 'Notifications',
      profile: 'Profile',
      
      // Cases
      cases: 'Cases',
      caseNumber: 'Case Number',
      caseTitle: 'Case Title',
      caseDescription: 'Case Description',
      caseStatus: 'Case Status',
      createCase: 'Create New Case',
      viewCase: 'View Case',
      editCase: 'Edit Case',
      
      // Status
      pending: 'Pending',
      active: 'Active',
      closed: 'Closed',
      appealed: 'Appealed',
      
      // Common
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      view: 'View',
      upload: 'Upload',
      download: 'Download',
      search: 'Search',
      filter: 'Filter',
      loading: 'Loading...',
      noData: 'No data available',
      success: 'Success',
      error: 'Error',
      
      // Auth
      email: 'Email',
      password: 'Password',
      fullName: 'Full Name',
      phone: 'Phone',
      loginTitle: 'Login',
      registerTitle: 'Create Account',
      forgotPassword: 'Forgot Password?',
      dontHaveAccount: "Don't have an account?",
      alreadyHaveAccount: 'Already have an account?',
      
      // Services
      ourServices: 'Our Legal Services',
      individuals: 'For Individuals',
      businesses: 'For Businesses',
      litigation: 'Litigation',
      contracts: 'Contracts',
      consultation: 'Consultation',
      
      // Departments
      legalDepartments: 'Legal Departments',
      litigationDept: 'Litigation Department',
      contractsDept: 'Contracts Department',
      intellectualProperty: 'Intellectual Property',
      cybercrimes: 'Cybercrimes',
      realEstate: 'Real Estate Registration',
      
      // Contact
      contactUs: 'Contact Us',
      sendMessage: 'Send Message',
      message: 'Message',
      subject: 'Subject',
      
      // Footer
      allRightsReserved: 'All Rights Reserved',
      privacyPolicy: 'Privacy Policy',
      termsConditions: 'Terms & Conditions',
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'ar', // Default language: Arabic
    fallbackLng: 'ar',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;